import ApiService from "../../../services/api.service";

const RestaurantProductService = {

	getItems(payload, data) {
		return ApiService.post(`/item/search/categories?page=${payload.page}&limit=${payload.limit}`, data ? data : { categoryId: 14 })
	},
	getList(search) {
		return ApiService.post(`/restaurantProduct/listSearch?search=${search}`, { page: 1, limit: 10000 })
	},
	createProduct(data) {
		return ApiService.post(`/restaurantProduct/create`, data)
	},
	updateProduct(data) {
		return ApiService.put(`/restaurantProduct/update/${data.id}`, data)
	},
	deleteProduct(id) {
		return ApiService.delete(`/restaurantProduct/delete/${id}`)
	},
	activeOrInactive(item) {
		return ApiService.delete(`/restaurantProduct/delete/${item.id}?status=${item.status}`)
	},
	setImageProduct(id, form) {
		return ApiService.post(`/restaurantProduct/addPhotoRestaurantProduct/${id}`, form)
	},
	generateBarcode() {
		return ApiService.get(`/item/generate-barcode-with-product`)
	},
	getListByGroup(groupId, depId) {
		return ApiService.get(`/restaurantGroup/productListByGroupId/${groupId}/${depId}`)
	},
	deletePhotoProduct(productId, photoId) {
		return ApiService.get(`/restaurantProduct/${productId}/remove-product-photo/${photoId}`)
	}

}

export default RestaurantProductService
